import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

function Experience() {
    const experiences = [
        {
            title: "ISEF national finalist",
            description: "Developed a Brain tumor detection system that simulates how a doctor examines MRI images and achieved 98.7% accuracy using a hybrid approach with Resnet and Inception designs using Tensorflow and Mistral 7B model from Hugging face",
            achievement: "Was part of the best 135 projects among 3000 projects in the competition",
            image: "/ISEF.jpg",
            reverse: false
        },
        {
            title: "Data Science & ML",
            description: "3 Years of continous effort to learning programming,data science and machine learning, building projects and applying to real world problems",
            achievement: "Transformed messy data from a twitter account that rate dogs into clean data and extracted useful insights for a report",
            image: "https://yt3.googleusercontent.com/JLNWz9uTYLgtz6yD8uk7sYOMsfglQYLTQLtnCZByo98k2LhzEtuX5nxeZWSplPk5RMcLMWom=s900-c-k-c0x00ffffff-no-rj",
            reverse: true
        },
        {
            title: <a className='animate-pulse' href='https://github.com/youssef124wael/Churn_prediction'>Churn prediction system</a>,
            description:"Developed a churn prediction system with my teammates which included Data analysis,cleaning,feature engineering and ML development to make a suitable model to predict if a customer will churn or not",
            achievement:"The system was able to predict if a customer will churn or not with 0.912 AUC score on kaggle churn competition S6E3",
            image: "https://github.com/youssef124wael/Churn_prediction/raw/main/assets/churn_img.jpeg",
            reverse: false
        },
        {
            title:<a className='animate-pulse' href='https://www.campusodyssey.org/'>Campus odyssey</a>,
            description:"Participated in the development of campus odyssey website which is a website that help students in egypt to know more about the admission process in arabic easing the search for information",
            achievement:"The website was built using React and Tailwind CSS and was deployed on Vercel",
            image: "/campus odyssey.jpeg",
            reverse:true,
        }
    ];

    return (
        <div id='experience' className='py-20 rounded-2xl bg-[#0F0F23]'>
            <div className='max-w-6xl mx-auto px-6'>
                <h1 className='text-center text-[60px] max-md:text-[40px] text-white font-bold mb-20'>
                    Experience & Achievements
                </h1>

                {experiences.map((exp, index) => (
                    <ExperienceCard key={index} experience={exp} />
                ))}
            </div>
        </div>
    );
}

function ExperienceCard({ experience }) {
    const [ref, inView] = useInView({
        threshold: 0.3,
        triggerOnce: true,
    });

    return (
        <motion.div
            ref={ref}
            className={`flex flex-col md:flex-row items-center gap-12 ${experience.reverse ? 'md:flex-row-reverse' : ''}`}
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
        >
            {/* Text Section */}
            <div className='flex-1'>
                <motion.div
                    className=' p-0.5'
                    initial={{ opacity: 0 }}
                    animate={inView ? { opacity: 1 } : {}}
                    transition={{ duration: 1 }}
                >
                    <div className=' rounded-lg p-8'>
                        <h2 className='text-3xl font-bold text-white mb-4'>{experience.title}</h2>
                        <p className='text-gray-300 text-lg mb-6 leading-relaxed'>{experience.description}</p>
                        <div className='border-l-4 border-cyan-400 pl-4'>
                            <p className='text-green-400 font-semibold text-lg'>{experience.achievement}</p>
                        </div>
                    </div>
                </motion.div>
            </div>

            {/* Image Section */}
            <motion.div
                className='flex-1'
                initial={{ opacity: 0, scale: 0.8 }}
                animate={inView ? { opacity: 1, scale: 1 } : {}}
                transition={{ duration: 0.8 }}
            >
                <div className=' rounded-lg p-0.5'>
                    <img
                        src={experience.image}
                        alt={experience.title}
                        className='w-full h-80 object-cover rounded-lg'
                    />
                </div>
            </motion.div>
        </motion.div>
    );
}

export default Experience;
